<template>
  <div class="row mt-4 ms-1 me-1">
    <section-header>Priorytet</section-header>
    <div class="body">
      <div
        class="importance row mt-2"
        v-for="importance in importances"
        :key="importance.id"
      >
        <div class="col-3">
          <importance-zero v-if="importance.level === 0" />
          <importance-one v-else-if="importance.level === 1" />
          <importance-two v-else-if="importance.level === 2" />
          <importance-three v-else-if="importance.level === 3" />
        </div>
        <div class="col-9 description">
          <span v-if="importance.description">{{
            importance.description
          }}</span>
          <span v-else-if="importance.level === 0"
            >Nie ma wpływu na jazdę.</span
          >
          <span v-else-if="importance.level === 1"
            >Ma wpływ na jazdę i/lub bezpieczeństwo.</span
          >
          <span v-else-if="importance.level === 2"
            >Dopuszczalny tylko dojazd do warsztatu.</span
          >
          <span v-else-if="importance.level === 3"
            >Wyłącz silnik i wezwij lawetę.</span
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ImportanceTwo from "@/components/icons/importances/ImportanceTwo";
import ImportanceThree from "@/components/icons/importances/ImportanceThree";
import SectionHeader from "@/components/fault-detail-components/SectionHeader";
import ImportanceZero from "@/components/icons/importances/ImportanceZero";
import ImportanceOne from "@/components/icons/importances/ImportanceOne";

export default {
  props: {
    importances: [],
  },
  components: {
    ImportanceOne,
    ImportanceZero,
    SectionHeader,
    ImportanceTwo,
    ImportanceThree,
  },
};
</script>
<style scoped>
.importance .description {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
}
</style>
